export default class Validator {
    constructor(input) {
        this.input = input;
        this.form = input.form;
    }

    // Checks input to see if it is valid
    valid() {
        return Promise.resolve(false);
    }

    // Checks to see if the input field uses this validator
    static applies(input) {
        return false;
    }
}
